import { render, staticRenderFns } from "./todayPlayerPointSpecial2.vue?vue&type=template&id=593d59cd&scoped=true&"
import script from "./todayPlayerPointSpecial2.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPointSpecial2.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPointSpecial2.vue?vue&type=style&index=0&id=593d59cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d59cd",
  null
  
)

export default component.exports